import React from 'react';
import './card.scss';
export var CardBody = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "c-card__body" }, children);
};
